import * as React from "react";

import { RobotoDomainException } from "./exceptions";

/**
 * Maps a thrown error to user-facing copy for inline error surfaces.
 *
 * For a backend-raised HTTP 4XX (not found, forbidden, validation, etc.)
 * the message is server-authored and safe to show; return it verbatim.
 * For anything else — 5XX, network drops, framework errors, non-Error
 * throws — return `fallback` (or a generic support-mailto message when
 * omitted) so server-internal details never reach the user.
 */
export function userFacingErrorMessage(
  error: unknown,
  fallback?: React.ReactNode,
): React.ReactNode {
  if (error instanceof RobotoDomainException && error.isClientError()) {
    return error.message;
  }
  if (fallback !== undefined) {
    return fallback;
  }
  return defaultFallbackMessage;
}

const defaultFallbackMessage: React.ReactNode = (
  <>
    Something went wrong. Please contact{" "}
    <a href="mailto:support@roboto.ai">support@roboto.ai</a> if this problem
    persists.
  </>
);
